export default __webpack_public_path__ + "static/media/skejuul-loader.bb1b6c9e.gif";